import { Dialog, DialogActions, DialogTitle } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { message } from "antd";
import { removeAssistant } from "./service";

function AssistantDelete(props) {
  const { isOpen, onClose, onDelete, assistant } = props;
  const [loading, setLoading] = useState(false);

  async function handleDeleteAssistant() {
    setLoading(true);
    await onDelete();
    setLoading(false);
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Delete {assistant.name}?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button loading={loading} onClick={handleDeleteAssistant}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { AssistantDelete };
